import React, { useState } from "react";
import { useExport } from "@pankod/refine-core";
import {
  List,
  useTable,
  EditButton,
  TableColumnType,
  Button,
  Table,
  BooleanField,
} from "@pankod/refine-antd";
import { renderNumber, renderDate } from "utils/render";

export const BotList = () => {
  const { tableProps, searchFormProps, sorter } = useTable({
    queryOptions: { retry: false },
  });
  const { triggerExport } = useExport({
    sorter: sorter,
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bot_id",
        title: "Bot Id",
        type: "number",
        width: 80,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "name",
        title: "Name",
        width: 200,
        fixed: "left",
      },
      {
        dataIndex: "symbol",
        title: "Symbol",
        width: 200,
      },
      {
        dataIndex: "symbol_display",
        title: "Symbol Display",
        width: 200,
      },
      {
        dataIndex: "min_usd_start",
        title: "Min Usd Start",
        type: "number",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 2, undefined, { style: style });
        },
      },
      {
        dataIndex: "min_usd_stop",
        title: "Min Usd Stop",
        type: "number",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 2, undefined, { style: style });
        },
      },
      {
        dataIndex: "bot_file_name",
        title: "Filename",
        width: 200,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "timeframe",
        title: "Time Frame",
        width: 200,
      },
      {
        dataIndex: "leverage",
        title: "Leverage",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 2, undefined, { style: style });
        },
      },
      {
        dataIndex: "tag",
        title: "Tag",
        width: 200,
      },
      {
        dataIndex: "percent_win_rate",
        title: "Perrcent Win Rate",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 2, undefined, { style: style });
        },
      },
      {
        dataIndex: "total_percent_return",
        title: "Total Percent Return",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 2, undefined, { style: style });
        },
      },
      {
        dataIndex: "percent_max_draw_down",
        title: "Percent Max Draw Down",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 2, undefined, { style: style });
        },
      },
      {
        dataIndex: "recovery_period",
        title: "Rovery Period",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 0, undefined, { style: style });
        },
      },
      {
        dataIndex: "trade_count",
        title: "Trade Count",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 0, undefined, { style: style });
        },
      },
      {
        dataIndex: "running_subscriptions",
        title: "Running Subscriptions",
        width: 200,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 0, undefined, { style: style });
        },
      },
      {
        dataIndex: "running_users",
        title: "Running Users",
        width: 200,
        sorter: true,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 0, undefined, { style: style });
        },
      },
      {
        dataIndex: "total_investment",
        title: "Total Investment",
        width: 200,
        sorter: true,
        render: (value) => {
          const style = {
            textAlign: "right",
          };
          return renderNumber(value, 2, undefined, { style: style });
        },
      },
      {
        dataIndex: "logo_url",
        title: "Logo",
        width: 200,
        render: (_, params) => {
          return params.logo_url ? (
            <img
              style={{
                height: "80px",
                width: "160px",
                padding: "10px",
              }}
              src={params.logo_url}
              alt="-"
            />
          ) : null;
        },
      },
      {
        dataIndex: "trend_type",
        title: "Trend Type",
        width: 200,
      },
      {
        dataIndex: "risk_type",
        title: "Risk Type",
        width: 200,
      },
      {
        dataIndex: "backtest_start_at",
        title: "Backtest Start At",
        width: 220,
        render: (value) => {
          return renderDate(value, {});
        },
      },
      {
        dataIndex: "backtest_end_at",
        title: "Backtest End At",
        width: 220,
        render: (value) => {
          return renderDate(value, {});
        },
      },
      {
        dataIndex: "is_actived",
        title: "Actived",
        type: "boolean",
        width: 200,
        render: (_, record) => {
          return (
            <BooleanField
              value={record.is_actived === true}
              trueIcon={"True"}
              falseIcon={"False"}
            />
          );
        },
      },
      {
        dataIndex: "show_explore",
        title: "Show Explore",
        type: "boolean",
        width: 200,
        render: (_, record) => {
          return (
            <BooleanField
              value={record.show_explore === true}
              trueIcon={"True"}
              falseIcon={"False"}
            />
          );
        },
      },
      // {
      //   dataIndex: "is_exclusive",
      //   title: "Is Exclusive",
      //   type: "boolean",
      //   width: 200,
      //   render: (_, record) => {
      //     return (
      //       <BooleanField
      //         value={record.is_exclusive === true}
      //         trueIcon={"True"}
      //         falseIcon={"False"}
      //       />
      //     );
      //   },
      // },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 220,
        render: (value) => {
          return renderDate(value, {});
        },
      },
      {
        dataIndex: "updated_at",
        title: "Updated At",
        width: 220,
        render: (value) => {
          return renderDate(value, {});
        },
      },
      {
        dataIndex: "deleted_at",
        title: "Deleted At",
        width: 220,
        render: (value) => {
          return renderDate(value, {});
        },
      },
      {
        dataIndex: "actions",
        title: "Actions",
        render: (_, record) => {
          return (
            <>
              <EditButton hideText recordItemId={record.bot_id} />
              {/* <DeleteButton hideText recordItemId={record.bot_id} /> */}
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        width: 100,
        fixed: "right",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="bot_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="large"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
